import React from 'react';
const DocumentSignerConfigContext = React.createContext({});
export const DocumentSignerConfigProvider = DocumentSignerConfigContext.Provider
export default DocumentSignerConfigContext
